/*------------------------------------*/
/*         RECOVER MESSAGES           */
/*------------------------------------*/

export const ERROR_MESSAGES = {
    'emptyField': 'emptyField',
    'emailFormat': 'emailFormat',
    'idbetisFormat': 'idbetisFormat'
};

export const RECOVER_DONE = 'El PIN ha sido enviado compruebe su correo.';
export const RECOVER_FAILED = 'Las credenciales son inválidas.';